var ArticleEditorModule = /** @class */ (function () {
    function ArticleEditorModule() {
    }
    return ArticleEditorModule;
}());
export { ArticleEditorModule };
